<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="mini" label-width="120px">
          <el-form-item label="产品编码" prop="pCode">
            <el-input v-model="searchForm.pCode"></el-input>
          </el-form-item>
          <el-form-item label="产品名称" prop="name">
            <el-input v-model="searchForm.name"></el-input>
          </el-form-item>
          <el-form-item label="产品型号" prop="modelName">
            <el-input v-model="searchForm.modelName"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="checkStatus">
            <el-select v-model="searchForm.checkStatus" multiple collapse-tags clearable @change="onSearch">
              <el-option :label="item.label" :value="item.value" v-for="item in checkStatusOptions" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回退标记" prop="rollbackFlag">
            <el-select v-model="searchForm.rollbackFlag" multiple collapse-tags clearable @change="onSearch">
              <el-option :label="item.label" :value="item.value" v-for="item in rollbackFlagOptions" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="拍样首套是否一致" prop="sameFlag">
            <el-select v-model="searchForm.sameFlag" multiple collapse-tags clearable @change="onSearch">
              <el-option :label="item.label" :value="item.value" v-for="item in sameFlagOptions" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处理结果" prop="handleFlag">
            <el-select v-model="searchForm.handleFlag" multiple collapse-tags @change="onSearch">
              <el-option :label="item.label" :value="item.value" v-for="item in handleFlagOptions" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传时间">
            <form-date-range :form="searchForm" startKey="startDate" :usingTime="false" endKey="endDate" valueFormat="yyyy-MM-dd"> </form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="onReset">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="$router.push({ path: '/newProduct/imgImport',query:{pCode: ''} })">上传图片</el-button>
      </template>
      <el-table
        border
        stripe
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB', textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        :data="tableData.list"
        :header-cell-class-name="headerStyle"
        :height="maxTableHeight"
        v-loading="loading"
      >
        <el-table-column label="产品编码" prop="pCode" width="120"> </el-table-column>
        <el-table-column label="产品名称" prop="name" width="150" show-overflow-tooltip> </el-table-column>
        <el-table-column label="产品型号" prop="modelName" width="90"> </el-table-column>
        <el-table-column label="投产新品变更时间" prop="productionTimeStr" width="160"> </el-table-column>
        <el-table-column label="视觉拍样图">
          <el-table-column label="视觉拍样图" prop="viewUploader" width="100">
            <template slot-scope="{ row }">
              <el-button type="text" v-if="row.viewUploadRecordId" @click="getImg(row, 1)">点击查看</el-button>
              <span v-else>未上传</span>
            </template>
          </el-table-column>
          <el-table-column label="视觉上传人员" prop="viewUploaderName" width="110"></el-table-column>
          <el-table-column label="拍样图上传时间" prop="viewUploadTimeStr" width="160"></el-table-column>
        </el-table-column>
        <el-table-column label="首套试制图">
          <el-table-column label="首套试制图" prop="createdByName" width="110">
            <template slot-scope="{ row }">
              <el-button type="text" v-if="row.firstUploadRecordId" @click="getImg(row, 2)">点击查看</el-button>
              <span v-else>未上传</span>
            </template>
          </el-table-column>
          <el-table-column label="首套上传人员" prop="firstUploaderName" width="110"></el-table-column>
          <el-table-column label="首套图上传时间" prop="firstUploadTimeStr" width="160"></el-table-column>
        </el-table-column>
        <el-table-column label="拍样首套是否一致" prop="sameFlagStr" width="140"> </el-table-column>
        <el-table-column label="不一致原因" prop="diffReason" width="110" show-overflow-tooltip> </el-table-column>
        <el-table-column label="不一致处理">
          <el-table-column label="处理结果" prop="handleFlagStr" width="110"></el-table-column>
          <el-table-column label="处理人" prop="handlerName" width="110"></el-table-column>
          <el-table-column label="处理时间" prop="handleTimeStr" width="160"></el-table-column>
        </el-table-column>
        <el-table-column label="状态" prop="checkStatusStr" width="120"> </el-table-column>
        <el-table-column label="回退标记" prop="rollbackFlagStr" width="110"> </el-table-column>
        <el-table-column label="上传时间" prop="createdDate" width="160"> </el-table-column>
        <el-table-column label="操作" width="220" align="center" fixed="right">
          <template slot-scope="{ row }">
            <!-- (isVision && !isImportVision) || ( isFirstSet && !isImportFirstSet) -->
            <el-button type="text" size="mini" @click="goImport(row)" v-show="(!row.viewUploadRecordId && isShowVisionImport) || (!row.firstUploadRecordId && isShowFirstSetImport)">去上传</el-button>
            <el-button type="text" size="mini" @click="promptingVision(row)" v-show="!row.viewUploadRecordId && isShowFirstSetImport">提醒视觉上传</el-button>
            <el-button type="text" size="mini" @click="goImport(row)" v-show="row.checkStatus == 6 && isShowAtypismHandle">处理</el-button>
            <el-button type="text" size="mini" @click="goImport(row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>
    <!-- 图片查看 -->
    <image-review :visible.sync="isShowVisionImg" v-if="isShowVisionImg" :rowData="rowData" />
  </content-panel>
</template>

<script>
import moment from 'moment';
import axios from '@/utils/axiosInstance';
import imageReview from './components/image-review-dialog.vue';
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: 'SamplePicturesImport',
  mixins: [tableMixin, pagePathMixin],
  components: { imageReview },
  data() {
    return {
      loading: false,
      loading2: false,
      imgFormVisible: false,
      isShowOmparison: false,
      isShowVisionImg: false,
      searchForm: {
        pCode: '',
        name: '',
        modelName: '',
        checkStatus: [],
        rollbackFlag: [],
        sameFlag: [],
        handleFlag: [],
        startDate: '',
        endDate: '',
      },
      tableData: {
        list: [],
        pageSize: 30,
        pageNum: 1,
        total: 0,
      },
      exportData: {},
      searchFormData: {},
      rowData: {},
      columnsData: [],
      imgType: 1,
      currencyForm: {
        pageSize: 30,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: '',
        hasCount: 'Y',
        groupAttr: '',
      },
    };
  },
  computed: {
    permitList() {
      return JSON.parse(localStorage.getItem('permitList'));
    },
    //视觉上传权限
    isShowVisionImport() {
      let Jurisdiction = 'ec-pc-new$productLifeCycle$aboutNew$SamplePicturesImport$visionImport';
      return this.permitList.includes(Jurisdiction)
    },
    //首套上传权限
    isShowFirstSetImport() {
      let Jurisdiction = 'ec-pc-new$productLifeCycle$aboutNew$SamplePicturesImport$firstSetImport';
      return this.permitList.includes(Jurisdiction)
    },
    //不一致处理权限
    isShowAtypismHandle() {
      let Jurisdiction = 'ec-pc-new$productLifeCycle$aboutNew$SamplePicturesImport$atypismHandle';
      return this.permitList.includes(Jurisdiction);
    },
    checkStatusOptions() {
      return [
        { label: '未上传', value: 1 },
        { label: '视觉已上传', value: 2 },
        { label: '首套已上传', value: 3 },
        { label: '已确认一致', value: 4 },
        { label: '已上传无需确认', value: 5 },
        { label: '不一致待处理', value: 6 },
        { label: '不一致已处理', value: 7 },
      ];
    },
    sameFlagOptions() {
      return [
        { label: '是', value: 1 },
        { label: '否', value: 2 },
        { label: '无需确认', value: 3 },
      ];
    },
    rollbackFlagOptions() {
      return [
        { label: '视觉回退', value: 1 },
        { label: '首套回退', value: 2 },
        { label: '视觉/首套回退', value: 3 },
      ];
    },
    handleFlagOptions() {
      return [
        { label: '视觉P图', value: 1 },
        { label: '重新打样', value: 2 },
      ];
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    onSearch() {
      console.log(this.searchForm);
      this.tableData.pageNum = 1;
      this.init();
    },
    onReset() {
      this.$refs.searchForm.resetFields();
      this.onSearch();
    },
    async init() {
      this.loading = true;
      let searchForm = JSON.parse(JSON.stringify(this.searchForm));
      let { checkStatus, rollbackFlag, sameFlag, handleFlag } = searchForm;
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.pageNum = this.tableData.pageNum;
      currencyForm.pageSize = this.tableData.pageSize;
      currencyForm.param = searchForm;
      currencyForm.param.checkStatus = checkStatus.length ? checkStatus.join(',') : '';
      currencyForm.param.rollbackFlag = rollbackFlag.length ? rollbackFlag.join(',') : '';
      currencyForm.param.sameFlag = sameFlag.length ? sameFlag.join(',') : '';
      currencyForm.param.handleFlag = handleFlag.length ? handleFlag.join(',') : '';
      currencyForm.reportCode = 'pageProductFirstUpload';
      axios
        .post(`/ec-pc-api/custom/reports/data/pageProductFirstUpload`, currencyForm)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
    getImg(row, type) {
      let id = type == 1 ? row.viewUploadRecordId : row.firstUploadRecordId;
      this.rowData = {
        id,
        imgType: type,
      };
      this.isShowVisionImg = true;
    },
    goImport(row) {
      this.openSubPage({
        path: '/newProduct/imgImport',
        query: {
          ...row,
        },
      });
    },
    async promptingVision(row) {
      let status = await this.$confirm('是否确认提醒上传', '提示', { type: 'warning' });
      if (status !== 'confirm') return;
      this.$q.newProduct.productCheckImgNotice({ data: { pcode: row.pCode } }).then((res) => {
        this.$message.success('提醒成功');
      });
    },
    headerStyle({ row, column, rowIndex, columnIndex }) {
      if ((column.label.includes('视觉') || column.label.includes('拍样')) && columnIndex < 6) {
        return 'color1';
      } else if (column.label.includes('首套') && columnIndex < 6) {
        return 'color2';
      } else if (column.label.includes('处理')) {
        return 'color3';
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.footerBox {
  text-align: right;
}

>>> .color1 {
  background: #FFE5DB !important;
}

>>> .color2 {
  background: #FBEDB9 !important;
}

>>> .color3 {
  background: #D9EFFF !important;
}

.search-box {
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input {
    width: 240px !important;
  }

  >>> .date-range .single-date {
    width: 110px !important;
  }
}
</style>
